export default "/images/widget.svg?ea254c5fda94edb40f8d5e3d518c5356";